import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Socialist Art · Inspire & Create</p>
        <h1>Unleash Your Creativity with Socialist Art</h1>
        <p className="lede">
          Discover a vibrant community where artists and enthusiasts come together to celebrate creativity and expression. Join us in exploring art that inspires and connects.
        </p>
        <div className="cta-row">
          <a href="/explore" target="_blank">
            Explore Our Gallery
          </a>
          <a href="/join" target="_blank" className="secondary">
            Join the Community
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Showcase Your Work</h2>
          <p>
            Share your art with a supportive audience. Our platform provides the perfect space to display your creativity and gain recognition.
          </p>
        </article>
        <article>
          <h2>Connect with Artists</h2>
          <p>
            Network with fellow artists and art lovers. Collaborate, share ideas, and inspire each other in a thriving artistic environment.
          </p>
        </article>
        <article>
          <h2>Participate in Events</h2>
          <p>
            Join our regular events, workshops, and exhibitions. Engage with the community and enhance your skills while having fun.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;